export const ReportsComponent = {
	transclude: true,
	templateUrl: 'reports.html',
	controller: class ReportsComponent {
		constructor(ReportsListerService, $translate, scrollToElement) {
			'ngInject';
			this.reportsListerService = ReportsListerService;
			this.currentPage = 0;
			this.size = 5;
			this.responseData = {};
			this.$translate = $translate;
			this.scrollToElement = scrollToElement;
		}

		$onInit() {
			this.pager(this.currentPage, this.size);
			this.reportsListerService.getYears().then((response) => {
				this.years = Array.isArray(response.data.years) ? response.data.years.sort().reverse() : [];
			}).catch(() => {
				console.log('hiba az évek lekérdezésekor');
			});
		}

		loadPage(event) {
			this.pager(event.pageTo, this.size);
		}

		newsForYear(year) {
			this.year = year;
			this.pager(this.currentPage, this.size);
		}

		pager(page, size) {
			let params = {
				page: page,
				size: size,
				lang: this.$translate.use()
			};
			this.reportsListerService.getReportsList(params, this.year).then(
				(response) => {
					this.responseData.news = response.data;
					this.scrollToElement('div.section__container--white', 500, true);
				},
				(error) => {
					console.log('hiba a hírek lekérdezésekor', error);
				}
			);
		}
	}
};
